module.exports = __webpack_public_path__ + "static/principles-of-oo-511b1101f0308a32839da39fb93420e5.png";